import * as types from './types'

export const getTradedFacilities = (payload: any) => ({
  type: types.GET_TRADED_FACILITIES,
  payload,
})

export const resetTradedFacilities = () => ({
  type: types.RESET_TRADED_FACILITIES,
  payload: null,
})

export const startLoadingTradedFacilities = () => ({
  type: types.START_LOADING_TRADED_FACILITIES,
  payload: null,
})

export const stopLoadingTradedFacilities = () => ({
  type: types.STOP_LOADING_TRADED_FACILITIES,
  payload: null,
})

export const addTradedFacilityFee = (payload: any) => ({
  type: types.ADD_TRADED_FACILITY_FEE,
  payload,
})

export const deleteTradedFacilityFee = (payload: any) => ({
  type: types.DELETE_TRADED_FACILITY_FEE,
  payload,
})

export const updateTradedFacilityFee = (payload: any) => ({
  type: types.UPDATE_TRADED_FACILITY_FEE,
  payload,
})

export const updateTradedFacilityAmount = (payload: any) => ({
  type: types.UPDATE_TRADE_FACILITY_AMOUNT,
  payload,
})

export const addTemporaryTradedFacility = (payload: any) => ({
  type: types.ADD_TEMPORARY_TRADE_FACILITY,
  payload,
})

export const deleteTradedFacilities = (payload: any) => ({
  type: types.DELETE_TRADED_FACILITIES,
  payload,
})
